<template>
    <div class="publication__donations content-width">
        <div class="publication__donations-row d-flex">
            <div class="publication__donations-item">
                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">
                        {{$store.getters.t('publication_pet_donations_need_sum_label')}}
                    </div>
                    <div class="publication__fieldset-input">
                        <input type="number" v-model="$v.need_sum.$model" :placeholder="$store.getters.t('publication_pet_donations_enter_sum')">
                    </div>
                    <div class="text-danger" v-if="!$v.need_sum.custom">{{$store.getters.t('publication_pet_donations_invalid_value')}}</div>
                </div>
            </div>
            <div class="publication__donations-item">
                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">
                        {{$store.getters.t('publication_pet_donations_thx_text_label')}}
                    </div>
                    <div class="publication__fieldset-input">
                        <textarea v-model="thx_text" :placeholder="$store.getters.t('publication_pet_donations_enter_text')"></textarea>
                    </div>
                    <div class="text-danger" v-show="$v.thx_text.$error">{{$store.getters.t('publication_pet_donations_thx_text_invalid')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { maxLength } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";
export default {
    name: "PublicationDonations",
    props: ['server'],
    mixins: [StateMixin],
    computed: {

        need_sum: {
            get() { return this.GET_BY_KEY('need_sum') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'need_sum', data:  val ? parseFloat(val) : null})
            }
        },

        thx_text: {
            get() { return this.GET_BY_KEY('thx_text') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'thx_text', data: val})
            }
        },

    },



    methods: {

        isValid(){

            if( this.need_sum ){
                this.$v.$touch();
                if( this.$v.$invalid ){
                    this.$emit('parent-update', false );
                    return false

                }

            }

            this.$emit('parent-update', true );
            return true

        }
    },

    validations:{
        need_sum: {
            custom(value){
                if( ! value ) return true
                return !!value && parseFloat(value) >= 0
            }
        },
        thx_text: { maxLength: maxLength(250) }
    }

}
</script>

<style scoped>

</style>
